export const FINANCIAL_INSTITUTION_OPTIONS = [
  "Royal Bank of Canada (RBC)",
  "Toronto-Dominion Bank (TD)",
  "Scotiabank",
  "Bank of Montreal (BMO)",
  "Canadian Imperial Bank of Commerce (CIBC)",
  "National Bank of Canada",
  "Desjardins",
  "ATB Financial",
  "Tangerine",
  "Simplii Financial",
  "EQ Bank",
  "Coast Capital",
  "Meridian Credit Union",
  "Vancity",
  "Laurentian Bank",
  "Canadian Western Bank",
  "Other",
];

const BANK_DETAILS_BY_NAME = {
  "Royal Bank of Canada (RBC)": {
    shortName: "RBC",
    credentialLabel: "Client Card or User name",
    forgotPasswordUrl: "https://www.rbcroyalbank.com/personal.html",
    logoUrl: "https://logo.clearbit.com/rbcroyalbank.com",
  },
  "Toronto-Dominion Bank (TD)": {
    shortName: "TD",
    credentialLabel: "Access Card or User name",
    forgotPasswordUrl: "https://www.td.com/ca/en/personal-banking",
    logoUrl: "https://logo.clearbit.com/td.com",
  },
  Scotiabank: {
    shortName: "Scotiabank",
    credentialLabel: "Card Number or User name",
    forgotPasswordUrl: "https://www.scotiabank.com/ca/en/personal.html",
    logoUrl: "https://logo.clearbit.com/scotiabank.com",
  },
  "Bank of Montreal (BMO)": {
    shortName: "BMO",
    credentialLabel: "Card Number or User name",
    forgotPasswordUrl: "https://www.bmo.com/main/personal",
    logoUrl: "https://logo.clearbit.com/bmo.com",
  },
  "Canadian Imperial Bank of Commerce (CIBC)": {
    shortName: "CIBC",
    credentialLabel: "Card Number or User name",
    forgotPasswordUrl: "https://www.cibc.com/en/personal-banking.html",
    logoUrl: "https://logo.clearbit.com/cibc.com",
  },
  "National Bank of Canada": {
    shortName: "National Bank",
    credentialLabel: "User name",
    forgotPasswordUrl: "https://www.nbc.ca/personal.html",
    logoUrl: "https://logo.clearbit.com/nbc.ca",
  },
  Desjardins: {
    shortName: "Desjardins",
    credentialLabel: "Access Code or User name",
    forgotPasswordUrl: "https://www.desjardins.com/ca/personal/index.jsp",
    logoUrl: "https://logo.clearbit.com/desjardins.com",
  },
  "ATB Financial": {
    shortName: "ATB",
    credentialLabel: "Client Card or User name",
    forgotPasswordUrl: "https://www.atb.com/personal/",
    logoUrl: "https://logo.clearbit.com/atb.com",
  },
  Tangerine: {
    shortName: "Tangerine",
    credentialLabel: "Client Number or User name",
    forgotPasswordUrl: "https://www.tangerine.ca/en",
    logoUrl: "https://logo.clearbit.com/tangerine.ca",
  },
  "Simplii Financial": {
    shortName: "Simplii",
    credentialLabel: "Card Number or User name",
    forgotPasswordUrl: "https://www.simplii.com/en.html",
    logoUrl: "https://logo.clearbit.com/simplii.com",
  },
  "EQ Bank": {
    shortName: "EQ Bank",
    credentialLabel: "Email or User name",
    forgotPasswordUrl: "https://www.eqbank.ca/",
    logoUrl: "https://logo.clearbit.com/eqbank.ca",
  },
  "Coast Capital": {
    shortName: "Coast Capital",
    credentialLabel: "Member Card or User name",
    forgotPasswordUrl: "https://www.coastcapitalsavings.com/",
    logoUrl: "https://logo.clearbit.com/coastcapitalsavings.com",
  },
  "Meridian Credit Union": {
    shortName: "Meridian",
    credentialLabel: "Member Number or User name",
    forgotPasswordUrl: "https://www.meridiancu.ca/personal",
    logoUrl: "https://logo.clearbit.com/meridiancu.ca",
  },
  Vancity: {
    shortName: "Vancity",
    credentialLabel: "Member Card or User name",
    forgotPasswordUrl: "https://www.vancity.com/Personal/",
    logoUrl: "https://logo.clearbit.com/vancity.com",
  },
  "Laurentian Bank": {
    shortName: "Laurentian",
    credentialLabel: "Client Number or User name",
    forgotPasswordUrl: "https://www.laurentianbank.ca/",
    logoUrl: "https://logo.clearbit.com/laurentianbank.ca",
  },
  "Canadian Western Bank": {
    shortName: "Canadian Western",
    credentialLabel: "User ID",
    forgotPasswordUrl: "https://www.cwbank.com/",
    logoUrl: "https://logo.clearbit.com/cwbank.com",
  },
  Other: {
    shortName: "Bank",
    credentialLabel: "Client Card or User name",
    forgotPasswordUrl: "",
    logoUrl: "",
  },
};

const DEFAULT_BANK_DETAILS = {
  shortName: "Bank",
  credentialLabel: "Client Card or User name",
  forgotPasswordUrl: "",
  logoUrl: "",
};

export const getBankDetails = (institutionName) => {
  if (!institutionName) {
    return DEFAULT_BANK_DETAILS;
  }

  return {
    ...DEFAULT_BANK_DETAILS,
    ...BANK_DETAILS_BY_NAME[institutionName],
  };
};
